import React from 'react';
import { Collapse } from 'react-collapse';
import { cs } from '@bbkAdminUtils/css-utils';
import './collapse-form-container.scss';
import type { ReactFCC } from '@bbkAdminUtils/utility-types';

type Props = {
  open: boolean;
  onToggle: (openState: boolean) => void;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  classes?: string;
  buttonClasses?: string;
};

export const CollapseFormContainerControlled: ReactFCC<Props> = (props) => {
  const {
    title = 'Show / Hide',
    subtitle,
    classes = 'CFC-default-theme',
    open = true,
    onToggle,
    buttonClasses,
    children,
  } = props;

  return (
    <div
      className={cs('collapse-form-container', classes, {
        'CFC-collapsed': !open,
        'CFC-expanded': open,
      })}
    >
      <button
        type="button"
        onClick={() => onToggle(!open)}
        className={cs('CFC-button', buttonClasses)}
      >
        {title}
        {subtitle && <span className="CFC-button-subtitle">{subtitle}</span>}
      </button>
      <Collapse isOpened={open}>{children}</Collapse>
    </div>
  );
};
